// 响应式工具函数
// 注意：SCSS变量无法在JS中直接导入，使用硬编码值

// 检测是否为移动设备
export const isMobile = () => {
  return window.innerWidth <= 768
}

// 检测是否为平板设备
export const isTablet = () => {
  return window.innerWidth > 768 && window.innerWidth <= 1024
}

// 检测是否为桌面设备
export const isDesktop = () => {
  return window.innerWidth > 1024
}

// 获取当前屏幕尺寸
export const getScreenSize = () => {
  const width = window.innerWidth
  
  if (width <= 480) return 'xs'
  if (width <= 768) return 'sm'
  if (width <= 992) return 'md'
  if (width <= 1200) return 'lg'
  return 'xl'
}

// 检测是否为触摸设备
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

// 获取设备像素比
export const getDevicePixelRatio = () => {
  return window.devicePixelRatio || 1
}

// 响应式事件监听器
export const createResponsiveListener = (callback) => {
  let timeoutId = null
  
  const handleResize = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    
    timeoutId = setTimeout(() => {
      callback({
        width: window.innerWidth,
        height: window.innerHeight,
        screenSize: getScreenSize(),
        isMobile: isMobile(),
        isTablet: isTablet(),
        isDesktop: isDesktop()
      })
    }, 100)
  }
  
  window.addEventListener('resize', handleResize)
  
  // 返回清理函数
  return () => {
    window.removeEventListener('resize', handleResize)
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
  }
}

// Vue混入 - 响应式数据
export const responsiveMixin = {
  data() {
    return {
      screenSize: getScreenSize(),
      isMobile: isMobile(),
      isTablet: isTablet(),
      isDesktop: isDesktop(),
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }
  },
  
  mounted() {
    this.responsiveCleanup = createResponsiveListener((data) => {
      this.screenSize = data.screenSize
      this.isMobile = data.isMobile
      this.isTablet = data.isTablet
      this.isDesktop = data.isDesktop
      this.windowWidth = data.width
      this.windowHeight = data.height
    })
  },
  
  beforeDestroy() {
    if (this.responsiveCleanup) {
      this.responsiveCleanup()
    }
  }
}

// 响应式断点检查 - 与SCSS变量保持一致
export const breakpoint = {
  xs: 480,    // $breakpoint-xs
  sm: 768,    // $breakpoint-sm
  md: 992,    // $breakpoint-md
  lg: 1200,   // $breakpoint-lg
  xl: 1920    // $breakpoint-xl
}

// 检查当前屏幕是否匹配断点
export const matchesBreakpoint = (size) => {
  const width = window.innerWidth
  const bp = breakpoint[size]
  
  if (!bp) return false
  
  switch (size) {
    case 'xs':
      return width <= bp
    case 'sm':
      return width > breakpoint.xs && width <= bp
    case 'md':
      return width > breakpoint.sm && width <= bp
    case 'lg':
      return width > breakpoint.md && width <= bp
    case 'xl':
      return width > breakpoint.lg
    default:
      return false
  }
}

// 响应式图片处理
export const getResponsiveImage = (images) => {
  const size = getScreenSize()
  
  if (images[size]) {
    return images[size]
  }
  
  // 降级处理
  if (size === 'xl' && images.lg) return images.lg
  if (size === 'lg' && images.md) return images.md
  if (size === 'md' && images.sm) return images.sm
  if (size === 'sm' && images.xs) return images.xs
  
  // 默认返回第一个可用的图片
  return Object.values(images)[0] || ''
}

// 移动端优化工具
export const mobileOptimizations = {
  // 防止双击缩放
  preventDoubleTapZoom: () => {
    let lastTouchEnd = 0
    document.addEventListener('touchend', (event) => {
      const now = (new Date()).getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    }, false)
  },
  
  // 设置视口
  setViewport: () => {
    const viewport = document.querySelector('meta[name="viewport"]')
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
    }
  },
  
  // 优化滚动性能
  optimizeScroll: () => {
    document.body.style.webkitOverflowScrolling = 'touch'
  }
} 